import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

export const jobIsEditable = (status: string) => {
  return (
    JOB_STATUSES_ENUM[status as keyof typeof JOB_STATUSES_ENUM] === JOB_STATUSES_ENUM.JOB_STATUS_DRAFT ||
    JOB_STATUSES_ENUM[status as keyof typeof JOB_STATUSES_ENUM] === JOB_STATUSES_ENUM.JOB_STATUS_SCHEDULED
  );
};
